import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("606_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  getToken: () => localStorage.getItem("606_token"),
  getUser: () => {
    const u = localStorage.getItem("606_user");
    return u ? JSON.parse(u) : null;
  },
  setSession: (token, user) => {
    localStorage.setItem("606_token", token);
    localStorage.setItem("606_user", JSON.stringify(user));
  },
  clear: () => {
    localStorage.removeItem("606_token");
    localStorage.removeItem("606_user");
  },
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_16570efc-dc79-4acb-85bb-43eb4c273127/artifacts/0ugtrfqw_logo_basic.png";

// Compact icon-only mark (orange triangle, no text) — used in navbar/footer
export const ICON_URL =
  "https://customer-assets.emergentagent.com/job_gaming-hub-bot/artifacts/j8e8o1os_customcolor_icon_customcolor_background.png";

// Animated hero centerpiece
export const HERO_ANIMATION_URL =
  "https://customer-assets.emergentagent.com/job_gaming-hub-bot/artifacts/pdyywlxu_animation_sync_Contrast_ykvtozjia.gif";
